<app-pageheader [Parent]="this">
  <add-button AddRoute="/enforcement/notices/noticetriggersets/new"></add-button>
</app-pageheader>

<app-datalistview
  [Columns]="Columns"
  [ShowMap]="false"
  ApiUrl="enforcement/noticetriggersets/searches"
  [AllowEdit]="true"
  EditUrl="enforcement/notices/noticetriggersets/:id">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>

